import qs from 'query-string';

import * as actionTypes from '../../constants/actionTypes';
import { persistor } from '../index';

export const setToken = (payload) => ({
  type: actionTypes.AUTH_SET_TOKEN,
  payload,
});

export const signOutCognito = () => (dispatch) => {
  localStorage.removeItem('isActiveSession');

  window.location.href = qs.stringifyUrl({
    url: `https://${import.meta.env.VITE_COGNITO_DOMAIN}/logout`,
    query: {
      client_id: import.meta.env.VITE_COGNITO_CLIENT_ID,
      logout_uri: `${window.location.origin}/signout`,
    },
  });

  dispatch({ type: actionTypes.AUTH_SIGN_OUT });
  persistor.purge();
};
